import { render } from "./Navbar.vue?vue&type=template&id=748578f4"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=748578f4&lang=css"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__